import { render, staticRenderFns } from "./phoneNumberBill.vue?vue&type=template&id=37c22506"
import script from "./phoneNumberBill.vue?vue&type=script&lang=js"
export * from "./phoneNumberBill.vue?vue&type=script&lang=js"
import style0 from "./phoneNumberBill.vue?vue&type=style&index=0&id=37c22506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports